<template>
  <div>
    <PageTitle
      :english="$t('forgot.title')"
      :title="$t('forgot.title')"
      :content="bannerText"
      :center="true"
    />

    <div class="form form-card">
      <div class="form-card__container form-card__container--sm">
        <!-- 步驟一: 輸入帳號 -->
        <el-form
          v-show="IsNowType === 1"
          ref="MemberForgetPasswordForm"
          class="forgot-password__form"
          :model="MemberForgetPasswordForm"
          :rules="MemberForgetPasswordRules"
          @submit.prevent.native
        >
          <el-form-item prop="memberAccount" class="form-field">
            <label class="form-label">{{ $t('forgot.label.account') }}</label>
            <el-input
              v-model="MemberForgetPasswordForm.memberAccount"
              :placeholder="$t('forgot.placeholder.account')"
              type="text"
              size="large"
              prefix-icon="el-icon-user"
            />
          </el-form-item>

          <div class="form-group form-group--inline">
            <el-form-item prop="captchaCode" class="form-field form-field--flex">
              <label class="form-label">{{ $t('common.label.captcha') }}</label>
              <el-input
                v-model="MemberForgetPasswordForm.captchaCode"
                :placeholder="$t('login.placeholder.captchaCode')"
                type="text"
                size="large"
                prefix-icon="el-icon-picture"
              />
            </el-form-item>
            <div class="captcha-image" @click="GetCaptchaCode">
              <img :src="`data:image/png;base64,${CodeImg}`" :alt="$t('common.label.captcha')" />
            </div>
          </div>

          <button
            class="btn-submit full"
            @click="MemberForgetPassword"
          >
            {{ $t('common.button.submit') }}
          </button>

          <div class="form-footer">
            <router-link to="/login" class="form-link form-link--primary">
              <i class="el-icon-back"></i>
                {{ $t('forgot.link.backToLogin') }}
            </router-link>
          </div>
        </el-form>

        <el-form
          v-show="IsNowType === 2"
          ref="MemberCheckCaptchaCodeForm"
            class="forgot-password__form"
          :model="MemberCheckCaptchaCodeForm"
          :rules="MemberCheckCaptchaCodeRules"
          @submit.prevent.native
        >
          <div class="form-verification">
            <el-form-item prop="captchaCode" class="form-field form-field--flex">
              <label class="form-label">{{ $t('forgot.label.emailCode') }}</label>
              <el-input
                v-model="MemberCheckCaptchaCodeForm.captchaCode"
                :placeholder="$t('forgot.placeholder.emailCode')"
                type="text"
                size="large"
                prefix-icon="el-icon-message"
              />
            </el-form-item>
            <el-button
              type="success"
              size="large"
              :disabled="isDisabled"
                class="forgot-password__send-code"
              @click="MemberSendCaptchaCode"
            >
              <i class="el-icon-s-promotion"></i>
              {{ CaptchaCodeTxt }}
            </el-button>
          </div>

          <button
            class="btn-submit full"
            @click="MemberCheckCaptchaCode"
          >
            {{ $t('common.button.submit') }}
          </button>
        </el-form>

        <!-- 步驟三: 設定新密碼 -->
        <el-form
          v-show="IsNowType === 3"
          ref="SaveMemberForgetPasswordForm"
          class="forgot-password__form"
          :model="SaveMemberForgetPasswordForm"
          :rules="SaveMemberForgetPasswordRules"
          @submit.prevent.native
        >
          <el-form-item prop="memberNewPassword" class="form-item">
            <label class="form-label">{{ $t('forgot.label.newPassword') }}</label>
            <el-input
              v-model="SaveMemberForgetPasswordForm.memberNewPassword"
              :placeholder="$t('forgot.placeholder.newPassword')"
              type="password"
              size="large"
              prefix-icon="el-icon-lock"
              show-password
            />
          </el-form-item>

          <el-form-item prop="memberConfirmPassword" class="form-item">
            <label class="form-label">{{ $t('forgot.label.confirmPassword') }}</label>
            <el-input
              v-model="SaveMemberForgetPasswordForm.memberConfirmPassword"
              :placeholder="$t('forgot.placeholder.confirmPassword')"
              type="password"
              size="large"
              prefix-icon="el-icon-lock"
              show-password
            />
          </el-form-item>

          <button
            class="btn-submit full"
            @click="SaveMemberForgetPassword"
          >
            {{ $t('common.button.submit') }}
          </button>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import {
  MemberForgetPassword,
  MemberSendCaptchaCode,
  MemberCheckCaptchaCode,
  SaveMemberForgetPassword,
} from '@/api/MemberApi';
import { GetCaptchaCode, GetCaptchaBase64 } from '@/api/CaptchaApi';

import PageTitle from '@/components/PageTitle.vue';

export default {
  components: {
    PageTitle,
  },
  data() {
    // 建立你的初始化 model data
    return {
      IsNowType: 1,
      timeOutProcessId: null,
      time: 60,
      isDisabled: false,
      CaptchaCodeTxt: '',
      CodeImg: '',
      MemberForgetPasswordForm: {
        // model data
        memberAccount: '',
        code: '',
        captchaCode: '',
      },
      MemberForgetPasswordRules: {
        // 檢查輸入的值規則
        memberAccount: [{ required: true, message: this.$t('common.message.accountRequired'), trigger: 'blur' }],
      },
      MemberCheckCaptchaCodeForm: {
        memberAccount: '',
        captchaCode: '',
        guid: '',
        memberMail: '',
      },
      MemberCheckCaptchaCodeRules: {
        // 檢查輸入的值規則
        captchaCode: [{ required: true, message: this.$t('forgot.validation.emailCodeRequired'), trigger: 'blur' }],
      },
      SaveMemberForgetPasswordForm: {
        memberAccount: '',
        newGuid: '',
        memberNewPassword: '',
        memberConfirmPassword: '',
      },
      SaveMemberForgetPasswordRules: {
        // 檢查輸入的值規則
        memberNewPassword: [
          { required: true, message: this.$t('validation.newPasswordRequired'), trigger: 'blur' },
          { min: 6, max: 20, message: this.$t('validation.passwordLength') },
          {
            pattern: /^([a-zA-Z]+\d+|\d+[a-zA-Z]+)[a-zA-Z0-9]*$/,
            message: this.$t('validation.passwordFormat'),
            trigger: 'blur',
          },
        ],
        memberConfirmPassword: [
          { required: true, message: this.$t('validation.confirmPasswordRequired'), trigger: 'blur' },
          { min: 6, max: 20, message: this.$t('validation.passwordLength') },
          {
            pattern: /^([a-zA-Z]+\d+|\d+[a-zA-Z]+)[a-zA-Z0-9]*$/,
            message: this.$t('validation.passwordFormat'),
            trigger: 'blur',
          },
        ],
      },
    };
  },
  created() {
    // 一開始執行的地方
    this.GetCaptchaCode();
    this.CaptchaCodeTxt = this.$t('forgot.button.sendCode');
  },
  methods: {
    // 你的 js function
    GetCaptchaCode() {
      // 取得驗證碼
      GetCaptchaCode().then((response) => {
        if (response.data.statusCode === 0) {
          this.MemberForgetPasswordForm.code = response.data.data.code;
          GetCaptchaBase64(this.MemberForgetPasswordForm.code).then((res) => {
            this.CodeImg = res.data;
          });
        }
      });
    },
    MemberForgetPassword() {
      // 忘記密碼
      this.MemberCheckCaptchaCodeForm.memberAccount = this.MemberForgetPasswordForm.memberAccount;
      this.SaveMemberForgetPasswordForm.memberAccount = this.MemberForgetPasswordForm.memberAccount;
      MemberForgetPassword(this.MemberForgetPasswordForm).then((response) => {
        if (response.data.statusCode === 0) {
          this.IsNowType = 2; // 進入第二步驟
          this.MemberCheckCaptchaCodeForm.guid = response.data.data.guid;
          this.MemberCheckCaptchaCodeForm.memberMail = response.data.data.memberMail;
          // 不馬上執行
          // this.MemberSendCaptchaCode();
        } else {
          this.GetCaptchaCode();
          this.IsNowType = 1; // 第一個步驟
          this.MemberCheckCaptchaCodeForm.memberAccount = ''; // 清空資料
          this.MemberCheckCaptchaCodeForm.guid = ''; // 清空資料
          this.MemberCheckCaptchaCodeForm.memberMail = ''; // 清空資料
          this.SaveMemberForgetPasswordForm.memberAccount = ''; // 清空資料
        }
      });
    },
    MemberSendCaptchaCode() {
      // 發送驗證信(一分鐘一次)
      MemberSendCaptchaCode(this.MemberCheckCaptchaCodeForm).then((response) => {
        if (response.data.statusCode === 0) {
          this.setTimeoutCountdown_CaptchaCode(); // 倒數60秒
          this.isDisabled = true;
          this.$message({
            showClose: true,
            type: 'success',
            message: this.$t('forgot.message.sendSuccess'),
          });
        }
      });
    },
    MemberCheckCaptchaCode() {
      // 驗證信箱的驗證碼
      if (this.MemberCheckCaptchaCodeForm.captchaCode !== '') {
        MemberCheckCaptchaCode(this.MemberCheckCaptchaCodeForm).then((response) => {
          if (response.data.statusCode === 0) {
            this.IsNowType = 3; // 進入第三步驟
            this.SaveMemberForgetPasswordForm.newGuid = response.data.data.newGuid;
          }
        });
      } else {
        this.$message({
          showClose: true,
          type: 'error',
          message: this.$t('forgot.validation.emailCodeRequired'),
        });
      }
    },
    SaveMemberForgetPassword() {
      // 修改密碼
      this.$refs.SaveMemberForgetPasswordForm.validate((valid) => {
        if (valid) {
          SaveMemberForgetPassword(this.SaveMemberForgetPasswordForm).then((response) => {
            if (response.data.statusCode === 0) {
              this.IsNowType = 1; // 回第一步驟
              this.$message({
                showClose: true,
                type: 'success',
                message: this.$t('forgot.message.success'),
              });
              // 清除
              this.MemberForgetPasswordForm = {
                memberAccount: '',
                code: '',
                captchaCode: '',
              };
              this.MemberCheckCaptchaCodeForm = {
                memberAccount: '',
                captchaCode: '',
                guid: '',
                memberMail: '',
              };
              this.SaveMemberForgetPasswordForm = {
                memberAccount: '',
                newGuid: '',
                memberNewPassword: '',
                memberConfirmPassword: '',
              };
              this.$router.push('/Login');
            }
          });
        }
      });
    },
    cleanTimeOut() {
      clearTimeout(this.timeOutProcessId);
      window.clearInterval(this.timeOutRefresh);
    },
    setTimeoutCountdown_CaptchaCode() {
      this.timeOutProcessId = setTimeout(() => {
        // time
        this.time -= 1;
        if (this.time === 0) {
          this.cleanTimeOut();
          this.time = 60;
          this.isDisabled = false;
          this.CaptchaCodeTxt = this.$t('forgot.button.sendCode');
        } else {
          this.CaptchaCodeTxt = this.$t('forgot.button.countdown', { seconds: this.time });
          this.setTimeoutCountdown_CaptchaCode();
        }
      }, 1000);
    },
  },
  computed: {
    bannerText() {
      if (this.IsNowType === 1) {
        return this.$t('forgot.step1Description');
      }

      if (this.IsNowType === 2) {
        return this.$t('forgot.step2Description', { email: this.MemberCheckCaptchaCodeForm.memberMail });
      }

      return this.$t('forgot.step3Description');
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/assets/scss/_variables.scss';

.forgot-password__send-code {
  flex-shrink: 0;
  width: 180px;

  @media (max-width: $breakpoint-sm) {
    width: 100%;
  }

  &:disabled {
    background-color: var(--border-base);
    border-color: var(--border-base);
    color: var(--text-secondary);
  }
}
</style>
